import { z } from "zod";
import {
  App,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import {
  emailSchema,
  passwordSchema,
  staticText as sharedText,
} from "@songtradr-sso/shared/frontend";
import { staticText } from "../../../shared/statics/static-text";
import { Api, handleMfa } from "../../../shared/utils/api.utils";

// TEXT
export const text = {
  ...staticText.emailSignIn,
  shared: { inputs: sharedText.inputs },
};

// STYLES

// DATA
export const emailPasswordSignIn = async (signInRequest: string) => {
  // Send the request...
  const result = await Api.request({
    method: "POST",
    url: endpoints.emailPasswordSignIn,
    data: { signInRequest },
  });

  // Check for MFA & return verification route if required...
  return handleMfa(result.data.data);
};

// TYPES
export type FormFields = z.infer<typeof schema>;

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].auth;

export const schema = z.object({
  [text.shared.inputs.email.id]: emailSchema,
  [text.shared.inputs.password.currentPassword.id]: passwordSchema,
});

// FUNCTIONS

// ASSETS
